export default "__VITE_ASSET__27991537__"